import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteContact,
  fetchContactList,
} from "../../services/contact.service";
import { enqueueSnackbar } from "notistack";

// fetch list
export const doFetchContactList = createAsyncThunk(
  "contact-us/fetchContactList",
  async (payload: any) => {
    try {
      const response: any = await fetchContactList({
        page: payload.page,
        limit: payload.limit,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch contact-us list";
      enqueueSnackbar(errorMessage, { variant: "error" });
      throw errorMessage;
    }
  }
);

// delete
export const doDelContact = createAsyncThunk(
  "contact-us/delContact",
  async (id: string) => {
    try {
      const response: any = await deleteContact(id);
      enqueueSnackbar("Contact Us data has been deleted successfully", {
        variant: "success",
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete message";
      enqueueSnackbar(errorMessage, { variant: "error" });
      throw errorMessage;
    }
  }
);
